webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(172);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(171);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueFilter = __webpack_require__(151);
	
	var _vueFilter2 = _interopRequireDefault(_vueFilter);
	
	var _vueValidator = __webpack_require__(173);
	
	var _vueValidator2 = _interopRequireDefault(_vueValidator);
	
	var _config = __webpack_require__(115);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _routes = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(126);
	__webpack_require__(127);
	
	_vue2.default.use(_vueFilter2.default);
	
	_vue2.default.filter('filename', function (value) {
	  return value.split(/(\\|\/)/g).pop();
	});
	
	_vue2.default.use(_vueValidator2.default);
	
	_vue2.default.validator('email', function (val) {
	  return (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val)
	  );
	});
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.http.options.root = _config2.default.API_ROOT;
	_vue2.default.http.options.emulateJSON = true;
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  history: true,
	  saveScrollPosition: true
	});
	
	(0, _routes.configRouter)(router);
	
	router.start(__webpack_require__(162), 'app');

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var showAlert = exports.showAlert = function showAlert(_ref, title, message, type, autohide) {
	  var dispatch = _ref.dispatch;
	
	  dispatch('ALERT', title, message, type, autohide);
	};

/***/ },
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  API_ROOT: 'https://operator.507.eu/api'
	};

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configRouter = configRouter;
	function configRouter(router) {
	
	  router.map({
	    '/': {
	      component: __webpack_require__(164)
	    },
	    '/jobs/:jobId': {
	      component: __webpack_require__(170)
	    },
	    '/applications/:uuid': {
	      component: __webpack_require__(169)
	    },
	    'privacypolicy': {
	      component: __webpack_require__(168)
	    },
	
	    '*': {
	      component: __webpack_require__(163)
	    }
	  });
	
	  router.redirect({});
	}

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(3);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(174);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var state = {
	  alerts: []
	};
	
	var mutations = {
	  ALERT: function ALERT(state, title, message, type, autohide) {
	
	    if (autohide == null) {
	      autohide = 5000;
	    }
	
	    var item = {
	      title: title,
	      message: message,
	      type: type,
	      autohide: autohide,
	      show: true
	    };
	
	    state.alerts.push(item);
	    var pos = state.alerts.length - 1;
	
	    setTimeout(function () {
	      state.alerts[pos].show = false;
	    }, autohide);
	  }
	};
	
	exports.default = new _vuex2.default.Store({
	  state: state,
	  mutations: mutations
	});

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _header = __webpack_require__(167);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _alerts = __webpack_require__(165);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _store = __webpack_require__(117);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  store: _store2.default,
	  components: {
	    PageHeader: _header2.default,
	    Alerts: _alerts2.default
	  }
	};

/***/ },
/* 119 */
/***/ function(module, exports) {

	"use strict";

/***/ },
/* 120 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      jobs: -1,
	      api: false
	    };
	  },
	  ready: function ready() {
	    var _this = this;
	
	    this.$http.get('jobs').then(function (response) {
	      _this.$set('jobs', response.data.data);
	    }, function (response) {
	      console.log("API ERROR", response);
	      _this.$set('jobs', -2);
	    });
	  }
	};

/***/ },
/* 121 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      defaults: {
	        danger: {
	          css: 'alert-danger',
	          title: 'Error!'
	        },
	        error: {
	          css: 'alert-danger',
	          title: 'Error!'
	        },
	        info: {
	          css: 'alert-info',
	          title: 'Info:'
	        },
	        success: {
	          css: 'alert-success',
	          title: 'Success!'
	        },
	        warning: {
	          css: 'alert-warning',
	          title: 'Warning!'
	        }
	      }
	    };
	  },
	
	  methods: {
	    hide: function hide(alert) {
	      alert.show = false;
	    },
	    messageTitle: function messageTitle(alert) {
	      if (alert.title != '') {
	        return alert.title;
	      } else if (alert.type) {
	        return this.defaults[alert.type].title;
	      }
	      return '';
	    }
	  },
	  vuex: {
	    getters: {
	      alerts: function alerts(state) {
	        return state.alerts;
	      }
	    }
	  }
	};

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(4);
	
	exports.default = {
	  data: function data() {
	    return {
	      form: {
	        firstName: "",
	        lastName: "",
	        email: "",
	        phone: "",
	        country: "",
	        file: "",
	        descriptionWhy: "",
	        descriptionAchieve: ""
	      },
	
	      processingForm: false
	    };
	  },
	
	  vuex: {
	    getters: {
	      alerts: function alerts(state) {
	        return state.alerts;
	      }
	    },
	    actions: {
	      alert: _actions.showAlert
	    }
	  },
	  methods: {
	    createApplication: function createApplication() {
	      var _this = this;
	
	      if (!this.$applicationValidation.valid) {
	
	        this.alert('Error!', 'Make sure there aren\'t any red underlined fields!');
	      } else {
	
	        $("#applyApplication").prop("disabled");
	
	        var form = new FormData();
	
	        form.append("firstName", this.form.firstName);
	        form.append("lastName", this.form.lastName);
	        form.append("email", this.form.email);
	        form.append("phone", this.form.phone);
	        form.append("country", this.form.country);
	        form.append("descriptionWhy", this.form.descriptionWhy);
	        form.append("descriptionAchieve", this.form.descriptionAchieve);
	        form.append("file", $('#file')[0].files[0]);
	
	        this.processingForm = true;
	
	        this.$http.post('jobs/' + this.$parent.job.id, form).then(function (response) {
	          _this.$router.go('/applications/' + response.data.data.uuid);
	        }, function (response) {
	          _this.alert('Error!', response.data.message);
	          _this.processingForm = false;
	
	          if (response.data.type === 1) {
	            _this.$setValidationErrors([{ field: "email", message: response.data.message, validator: "applicationValidation" }]);
	          }
	        });
	      }
	    }
	  },
	  ready: function ready() {
	    $('textarea').each(function () {
	      this.setAttribute('style', 'height:' + this.scrollHeight + 'px;overflow-y:hidden;');
	    }).on('input', function () {
	      this.style.height = 'auto';
	      var fix = 0;
	      if (this.scrollHeight === 40) {
	        fix = 16;
	      }
	      this.style.height = this.scrollHeight - fix + 'px';
	    });
	
	    $('.filename').click(function () {
	      $('#file').click();
	      return false;
	    });
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ },
/* 123 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  ready: function ready() {}
	};

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(4);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vueGoogleMaps = __webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _vueGoogleMaps.load)('AIzaSyBzlLYISGjL_ovJwAehh6ydhB56fCCpPQw');
	
	exports.default = {
	  components: {
	    map: _vueGoogleMaps.Map,
	    marker: _vueGoogleMaps.Marker
	  },
	  data: function data() {
	    return {
	      stored: false,
	      mapLocation: {
	        center: {
	          lat: 46.059937,
	          lng: 14.507978
	        },
	        pos: {
	          lat: 46.059937,
	          lng: 14.507978
	        }
	      },
	      mapOptions: {
	        styles: [{
	          "featureType": "administrative",
	          "elementType": "labels.text.fill",
	          "stylers": [{
	            "color": "#444444"
	          }]
	        }, {
	          "featureType": "landscape",
	          "elementType": "all",
	          "stylers": [{
	            "color": "#f2f2f2"
	          }]
	        }, {
	          "featureType": "landscape.man_made",
	          "elementType": "geometry",
	          "stylers": [{
	            "visibility": "on"
	          }]
	        }, {
	          "featureType": "poi",
	          "elementType": "all",
	          "stylers": [{
	            "visibility": "off"
	          }]
	        }, {
	          "featureType": "road",
	          "elementType": "all",
	          "stylers": [{
	            "saturation": -100
	          }, {
	            "lightness": 45
	          }]
	        }, {
	          "featureType": "road.highway",
	          "elementType": "all",
	          "stylers": [{
	            "visibility": "simplified"
	          }]
	        }, {
	          "featureType": "road.arterial",
	          "elementType": "labels.icon",
	          "stylers": [{
	            "visibility": "off"
	          }]
	        }, {
	          "featureType": "transit",
	          "elementType": "all",
	          "stylers": [{
	            "visibility": "off"
	          }]
	        }, {
	          "featureType": "water",
	          "elementType": "all",
	          "stylers": [{
	            "color": "#4f595d"
	          }, {
	            "visibility": "on"
	          }]
	        }],
	        streetViewControl: false,
	        zoomControl: false,
	        rotateControl: false,
	        panControl: false,
	        mapTypeControl: false
	      },
	      newDate: {
	        date: null,
	        note: null
	      },
	      application: {},
	      messages: {
	        0: {
	          title: 'Your application was send',
	          message: 'We haven\'t yet reviewed your Application.'
	        },
	        1: {
	          title: 'Thank you for your interest',
	          message: 'You can still follow our new vacancies.'
	        },
	        2: {
	          title: 'Consideration',
	          message: 'Your application is being Reviewed.'
	        },
	        3: {
	          title: 'Invited to the Interview',
	          message: 'You have been assigned an interview date. If it doesn\'t suits you, you can propose a new one here.'
	        },
	        4: {
	          title: 'Interview Confirmed',
	          message: 'We hope to see you at the interview in our studio. Click on red bubble for Google Maps'
	        },
	        5: {
	          title: 'Welcome to our Team',
	          message: 'Congratulations! Your Application has been Approved. We hope to see you soon.'
	        },
	
	        6: {
	          title: 'Interview Date waiting for Approval',
	          message: 'Your selected date is waiting for approval. We will notify you when approved.'
	        },
	        7: {
	          title: 'Not Accepted after Interview',
	          message: ''
	        },
	        8: {
	          title: 'We would like to store your contact',
	          message: ''
	        }
	      }
	    };
	  },
	  ready: function ready() {
	    this.loadData();
	
	    setInterval(this.loadData, 1000 * 60 * 5);
	  },
	
	  vuex: {
	    actions: {
	      alert: _actions.showAlert
	    }
	  },
	  methods: {
	    mapMarker: function mapMarker() {
	      window.open('https://goo.gl/maps/amL8CXuznB52', '_blank');
	    },
	    confirmInterview: function confirmInterview() {
	      var _this = this;
	
	      var data = new FormData();
	
	      data.append('uuid', this.$route.params.uuid);
	      data.append('interview', this.application.interview.id);
	
	      this.$http.post('applications/interview', data).then(function (response) {
	        _this.loadData();
	        _this.alert("Success", "Interview was confirmed.", "success");
	      }, function (response) {
	        _this.alert("Error!", "Something went wrong. Response: " + response.data.message, "danger");
	      });
	    },
	    confirmNewDate: function confirmNewDate() {
	      var _this2 = this;
	
	      if (!this.newDate) {
	        this.alert("Whops!", "You have to select date first.", "danger");
	      } else {
	        var data = new FormData();
	
	        data.append('uuid', this.$route.params.uuid);
	        data.append('interview', (0, _moment2.default)($('#interviewDate').data("DateTimePicker").date()).format());
	        data.append('note', this.newDate.note);
	
	        this.$http.post('applications/interview', data).then(function (response) {
	          _this2.loadData();
	          _this2.alert("Success", "Interview date was saved.", "success");
	        }, function (response) {
	          _this2.alert("Error!", "Something went wrong. Response: " + response.data.message, "danger");
	        });
	      }
	    },
	    loadData: function loadData() {
	      var _this3 = this;
	
	      if (this.$route.params.uuid) {
	        this.$http.get('applications/' + this.$route.params.uuid).then(function (response) {
	          var data = response.data.data;
	
	          if (data.interview) {
	            var date = (0, _moment2.default)(data.interview.date, "YYYY-MM-DD HH:mm:ss");
	            data.interview.date = date.isValid() ? date.format("DD-MM-YYYY") + " at " + date.format("HH:mm") : "Not set yet";
	          }
	
	          _this3.$set('application', data);
	          _this3.stored = response.data.data.stored;
	          $(function () {
	            $('[data-toggle="tooltip"]').tooltip();
	            $('#interviewDate').datetimepicker({
	              daysOfWeekDisabled: [0, 6],
	              icons: {
	                time: 'fa fa-clock-o',
	                date: 'fa fa-calendar',
	                up: 'fa fa-chevron-up',
	                down: 'fa fa-chevron-down',
	                previous: 'fa fa-chevron-left',
	                next: 'fa fa-chevron-right',
	                today: 'fa fa-desktop',
	                clear: 'fa fa-trash',
	                close: 'fa fa-times'
	              },
	              minDate: (0, _moment2.default)().add(1, 'd'),
	              maxDate: (0, _moment2.default)().add(3, 'w'),
	              stepping: 15,
	              inline: true,
	              sideBySide: true,
	              locale: 'sl'
	            });
	          });
	        }, function (response) {
	          console.log("API ERROR", response);
	        });
	      }
	    },
	    storedYes: function storedYes() {
	      var _this4 = this;
	
	      var data = new FormData();
	
	      data.append('uuid', this.$route.params.uuid);
	      data.append('aoutcome', 1);
	
	      this.$http.post('applications/store', data).then(function (response) {
	        _this4.loadData();
	        _this4.alert("Success", "Saved.", "success");
	      }, function (response) {
	        _this4.alert("Error!", "Something went wrong. Response: " + response.data.message, "danger");
	      });
	    },
	    storedNo: function storedNo() {
	      var _this5 = this;
	
	      var data = new FormData();
	
	      data.append('uuid', this.$route.params.uuid);
	      data.append('aoutcome', 0);
	
	      this.$http.post('applications/store', data).then(function (response) {
	        _this5.loadData();
	        _this5.alert("Success", "Saved.", "success");
	      }, function (response) {
	        _this5.alert("Error!", "Something went wrong. Response: " + response.data.message, "danger");
	      });
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _applicationForm = __webpack_require__(166);
	
	var _applicationForm2 = _interopRequireDefault(_applicationForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      job: {}
	    };
	  },
	
	  props: {
	    alerts: {
	      default: [],
	      type: Array
	    }
	  },
	  components: {
	    ApplicationForm: _applicationForm2.default
	  },
	  ready: function ready() {
	    var _this = this;
	
	    this.$http.get('jobs/' + this.$route.params.jobId).then(function (response) {
	      _this.$set('job', response.data.data[0]);
	    }, function (response) {
	      console.log("API ERROR", response);
	    });
	  }
	};

/***/ },
/* 126 */,
/* 127 */,
/* 128 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 129 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 130 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 131 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 132 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 133 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 134 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 135 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 136 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 137 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 138 */,
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 5,
		"./af.js": 5,
		"./ar": 11,
		"./ar-dz": 6,
		"./ar-dz.js": 6,
		"./ar-ly": 7,
		"./ar-ly.js": 7,
		"./ar-ma": 8,
		"./ar-ma.js": 8,
		"./ar-sa": 9,
		"./ar-sa.js": 9,
		"./ar-tn": 10,
		"./ar-tn.js": 10,
		"./ar.js": 11,
		"./az": 12,
		"./az.js": 12,
		"./be": 13,
		"./be.js": 13,
		"./bg": 14,
		"./bg.js": 14,
		"./bn": 15,
		"./bn.js": 15,
		"./bo": 16,
		"./bo.js": 16,
		"./br": 17,
		"./br.js": 17,
		"./bs": 18,
		"./bs.js": 18,
		"./ca": 19,
		"./ca.js": 19,
		"./cs": 20,
		"./cs.js": 20,
		"./cv": 21,
		"./cv.js": 21,
		"./cy": 22,
		"./cy.js": 22,
		"./da": 23,
		"./da.js": 23,
		"./de": 25,
		"./de-at": 24,
		"./de-at.js": 24,
		"./de.js": 25,
		"./dv": 26,
		"./dv.js": 26,
		"./el": 27,
		"./el.js": 27,
		"./en-au": 28,
		"./en-au.js": 28,
		"./en-ca": 29,
		"./en-ca.js": 29,
		"./en-gb": 30,
		"./en-gb.js": 30,
		"./en-ie": 31,
		"./en-ie.js": 31,
		"./en-nz": 32,
		"./en-nz.js": 32,
		"./eo": 33,
		"./eo.js": 33,
		"./es": 35,
		"./es-do": 34,
		"./es-do.js": 34,
		"./es.js": 35,
		"./et": 36,
		"./et.js": 36,
		"./eu": 37,
		"./eu.js": 37,
		"./fa": 38,
		"./fa.js": 38,
		"./fi": 39,
		"./fi.js": 39,
		"./fo": 40,
		"./fo.js": 40,
		"./fr": 43,
		"./fr-ca": 41,
		"./fr-ca.js": 41,
		"./fr-ch": 42,
		"./fr-ch.js": 42,
		"./fr.js": 43,
		"./fy": 44,
		"./fy.js": 44,
		"./gd": 45,
		"./gd.js": 45,
		"./gl": 46,
		"./gl.js": 46,
		"./he": 47,
		"./he.js": 47,
		"./hi": 48,
		"./hi.js": 48,
		"./hr": 49,
		"./hr.js": 49,
		"./hu": 50,
		"./hu.js": 50,
		"./hy-am": 51,
		"./hy-am.js": 51,
		"./id": 52,
		"./id.js": 52,
		"./is": 53,
		"./is.js": 53,
		"./it": 54,
		"./it.js": 54,
		"./ja": 55,
		"./ja.js": 55,
		"./jv": 56,
		"./jv.js": 56,
		"./ka": 57,
		"./ka.js": 57,
		"./kk": 58,
		"./kk.js": 58,
		"./km": 59,
		"./km.js": 59,
		"./ko": 60,
		"./ko.js": 60,
		"./ky": 61,
		"./ky.js": 61,
		"./lb": 62,
		"./lb.js": 62,
		"./lo": 63,
		"./lo.js": 63,
		"./lt": 64,
		"./lt.js": 64,
		"./lv": 65,
		"./lv.js": 65,
		"./me": 66,
		"./me.js": 66,
		"./mi": 67,
		"./mi.js": 67,
		"./mk": 68,
		"./mk.js": 68,
		"./ml": 69,
		"./ml.js": 69,
		"./mr": 70,
		"./mr.js": 70,
		"./ms": 72,
		"./ms-my": 71,
		"./ms-my.js": 71,
		"./ms.js": 72,
		"./my": 73,
		"./my.js": 73,
		"./nb": 74,
		"./nb.js": 74,
		"./ne": 75,
		"./ne.js": 75,
		"./nl": 77,
		"./nl-be": 76,
		"./nl-be.js": 76,
		"./nl.js": 77,
		"./nn": 78,
		"./nn.js": 78,
		"./pa-in": 79,
		"./pa-in.js": 79,
		"./pl": 80,
		"./pl.js": 80,
		"./pt": 82,
		"./pt-br": 81,
		"./pt-br.js": 81,
		"./pt.js": 82,
		"./ro": 83,
		"./ro.js": 83,
		"./ru": 84,
		"./ru.js": 84,
		"./se": 85,
		"./se.js": 85,
		"./si": 86,
		"./si.js": 86,
		"./sk": 87,
		"./sk.js": 87,
		"./sl": 88,
		"./sl.js": 88,
		"./sq": 89,
		"./sq.js": 89,
		"./sr": 91,
		"./sr-cyrl": 90,
		"./sr-cyrl.js": 90,
		"./sr.js": 91,
		"./ss": 92,
		"./ss.js": 92,
		"./sv": 93,
		"./sv.js": 93,
		"./sw": 94,
		"./sw.js": 94,
		"./ta": 95,
		"./ta.js": 95,
		"./te": 96,
		"./te.js": 96,
		"./tet": 97,
		"./tet.js": 97,
		"./th": 98,
		"./th.js": 98,
		"./tl-ph": 99,
		"./tl-ph.js": 99,
		"./tlh": 100,
		"./tlh.js": 100,
		"./tr": 101,
		"./tr.js": 101,
		"./tzl": 102,
		"./tzl.js": 102,
		"./tzm": 104,
		"./tzm-latn": 103,
		"./tzm-latn.js": 103,
		"./tzm.js": 104,
		"./uk": 105,
		"./uk.js": 105,
		"./uz": 106,
		"./uz.js": 106,
		"./vi": 107,
		"./vi.js": 107,
		"./x-pseudo": 108,
		"./x-pseudo.js": 108,
		"./yo": 109,
		"./yo.js": 109,
		"./zh-cn": 110,
		"./zh-cn.js": 110,
		"./zh-hk": 111,
		"./zh-hk.js": 111,
		"./zh-tw": 112,
		"./zh-tw.js": 112
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 139;


/***/ },
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/facebook.401a26b.png";

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/instagram.68d5b7e.png";

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/linkedin.5e36575.png";

/***/ },
/* 147 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pinterest.111ccc5.png";

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/web2.39c6bc1.png";

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/youtoube.98a20c9.png";

/***/ },
/* 151 */,
/* 152 */,
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = " <div class=app> <alerts></alerts> <page-header></page-header> <div class=\"application main\"> <router-view class=view></router-view> </div> <div class=footer> <div class=links> <a href=/privacypolicy> Privacy policy </a> <a href=http://facebook.com/507-Studio-307574720574/ target=_tab> <img src=" + __webpack_require__(144) + " /> </a> <a href=\"https://www.linkedin.com/company/507-?trk=company_logo\" target=_tab> <img src=" + __webpack_require__(146) + " /> </a> <a href=https://www.pinterest.com/507Studio/ target=_tab> <img src=" + __webpack_require__(148) + " /> </a> <a href=https://www.youtube.com/channel/UC6VTe3p8oCZuAAN1WM2ecvQ target=_tab> <img src=" + __webpack_require__(150) + " /> </a> <a href=http://507.design/ target=_tab> <img src=" + __webpack_require__(149) + " /> </a> <a href=https://www.instagram.com/507_studio/ target=_tab> <img src=" + __webpack_require__(145) + " /> </a> </div> <div class=pp> <p> Z oddajo tega obrazca se strinjate, da vpišemo vaše podatke v našo bazo. Vaše podatke obdelujemo skladno s Politiko zasebnosti, ki je objavljena na <a href=/privacypolicy>Privacy policy</a> in se bodo uporabljali samo za namene zaposlovanja. Vaši podatki bodo shranjeni v naši bazi podatkov izključno tako dolgo, kot je potrebno za te namene. Nobena podrobnost ne bo razkrita tretjim osebam, razen če je to zakonska zahteva. Na vašo željo bomo takoj odstranili vaše podatke iz naše baze podatkov. V primeru zavrnitve vaše ponudbe se stirnjate, da vase podakte ohranimo v naši bazi kandidatov še dve leti oz. do vašega preklica. </p> </div> </div> </div> ";

/***/ },
/* 154 */
/***/ function(module, exports) {

	module.exports = " <article> <div class=\"container-fluid error row\"> <p class=display-4><span class=display-3>404</span> You took a wrong turn</p> </div> <a class=\"btn btn-primary\" v-link=\"{ path: '/' }\"> Go Home</a> </article> ";

/***/ },
/* 155 */
/***/ function(module, exports) {

	module.exports = " <div class=go-center> <ul v-if=\"jobs !== -1 && jobs !== -2 && jobs.length !== 0\" class=jobs-list> <li v-for=\"job in jobs\" v-link=\"{ path: 'jobs/'+job.id }\" class=jobs-list-item> <p class=item-text> {{ job.title }} </p> </li> </ul> <h2 v-if=\"jobs.length === 0\" style=\"margin:0 2.5em\"> No Jobs available at the moment </h2> <h2 v-if=\"jobs === -1\" style=\"margin:0 2.5em\"> Loading ... </h2> <h2 v-if=\"jobs === -2\" style=\"margin:0 2.5em\"> Error loading jobs ... Please come back later </h2> </div> ";

/***/ },
/* 156 */
/***/ function(module, exports) {

	module.exports = " <div class=alert-wrapper> <div v-for=\"alert in alerts\" v-show=alert.show class=alert transition=alert @click=hide(alert) role=alert> <strong>{{ messageTitle(alert) }}</strong> {{ alert.message }} </div> </div> ";

/***/ },
/* 157 */
/***/ function(module, exports) {

	module.exports = " <validator name=applicationValidation> <form id=applicationForm class=row v-show=!processingForm novalidate> <h1 class=interested>Interested?</h1> <div class=\"form-group col-md-12\"> <label for=firstName>Name</label> <input v-validate:first-name=\"{ required: true, minlength: 2 }\" type=text class=form-control id=firstName v-model=form.firstName> </div> <div class=\"form-group col-md-12\"> <label for=lastName>Surname</label> <input v-validate:last-name=\"{ required: true, minlength: 2 }\" type=text class=form-control id=lastName v-model=form.lastName> </div> <div class=\"form-group col-md-12\"> <label for=email>Email</label> <input v-validate:email=\"['email']\" type=text class=form-control id=email v-model=form.email> </div> <div class=\"form-group col-md-12\"> <label for=phone>Phone Number</label> <input v-validate:phone=\"{ required: true}\" type=tel class=form-control id=phone v-model=form.phone> </div> <div class=\"form-group col-md-12\"> <label for=country>Country</label> <input v-validate:country=\"{ required: true }\" type=text class=form-control id=country v-model=form.country> </div> <div class=\"form-group col-md-12 thoughts\"> <p>You can share few thoughts with us (not necessary).</p> </div> <div class=\"form-group col-md-12\"> <label for=descriptionWhy>Why would you like to work for 507?</label> <textarea class=form-control v-model=form.descriptionWhy id=descriptionWhy rows=1></textarea> </div> <div class=\"form-group col-md-12\"> <label for=descriptionAchieve>What would be your goal with 507?</label> <textarea class=form-control v-model=form.descriptionAchieve id=descriptionAchieve rows=1></textarea> </div> <div v-validate-class class=\"form-group col-md-12 file-upload\"> <label class=file-label for=file>Add Your CV File</label> <span class=filename>{{ form.file | filename }}</span> <input v-validate:file=\"{ required: true }\" type=file v-model=form.file class=\"form-control-file btn-507\" id=file> </div> <button type=button v-on:click=createApplication class=\"btn-507 center-block\" id=applyApplication>Apply </button> </form> </validator> <div class=loading v-show=processingForm> <h3>Processing your request</h3> <div class=spinner> <div class=mask> <div class=maskedCircle></div> </div> </div> </div> ";

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = " <header> <a v-link=\"{ path: '/' }\" class=logo> <img src=" + __webpack_require__(147) + " /> </a> <div class=headline> <span class=seperator></span> <div class=content> <p> 507 is a production & design house, working in field <br/> of high technology furniture for luxury brands in design <br/> and beauty industry. We are specialized for in-store <br/> cosmetics furniture. </p> <p> <i>The majority of work is done for luxury brands like: </i><br/> <b> GUCCI, GUERLAIN, YSL, DIOR, DOLCE GABBANA, LANCOME, LOUIS VUITTON, <br/> BOSS, BURBERRY, ESCADA, GIVENCHY, CHANEL, ESTEE LAUDER, LA PRAIRE, <br/> CLINIQUE, ESCADA, LACOSTE, STELLA MCCARTNEY, ... </b> </p> </div> </div> </header> ";

/***/ },
/* 159 */
/***/ function(module, exports) {

	module.exports = " <h2>Recruitment Data Privacy Statement</h2> <p> Your privacy is important to 507 d.o.o. (»507«). This statement (the “Privacy Statement”) aims at informing you of how 507 entities will use the information you submit when applying for a job at 507 via the 507 website (\"Job Application Data\"). </p> <p> By submitting your personal information, you are consenting to the 507 holding and using it in accordance with this policy and general Privacy Policy, posted at jobs.507.eu. The policy is subject to change and any changes to it in the future will be notified on this page. By continuing to use this recruitment site you are agreeing to such changes. We recommend that you check the privacy policy each time you visit this site. </p> <p><i><b>Contents:</b></i></p> <ol> <li>1. Information that we collect from you and your use of this website</li> <li>2. Access and processing of your data</li> <li>3. Your rights</li> </ol> <h3>1.0 Information that we collect from you </h3> <p>This Privacy Statement covers any Job Application Data you submit to us, such as:</p> <ul> <li> Name, address, email address, telephone number, or other contact information; </li> <li> Information contained in your CV or cover letter, such as previous work experience, education, or other information you provide for our consideration; </li> <li> Type of employment sought, desired salary, willingness to relocate, or other job preferences, and </li> <li> Names and contact information for referrals </li> </ul> <p> It is your responsibility to obtain consent from references before providing their personal information to us. </p> <h4>1.2 Automatic Information </h4> <p> We automatically receive and save certain types of information whenever you interact with this website. We use the information to monitor website traffic and to assist with the navigation and user experience of the website. </p> <p>Information that we will automatically receive includes:</p> <ul> <li>Requested URL</li> <li>IP (Internet Protocol) address (this may or may not identify a specific computer)</li> <li>Domain name from which you access the internet</li> <li>Referring URL</li> <li>Software (browser/operating system) used to access the page</li> <li>Date and time pages were visited</li> </ul> <h3>2.0 Who can access your data</h3> <p> Personal data is collected to facilitate the recruitment process and used for anonymised reporting purposes. Data entered as part of an application is stored in the system and will be made available to an applicant to ‘re-use’ as part of a future application. </p> <p> Only select employees of 507 - such as your potential future manager(s), employees of the Human Resources Department, and IT (for maintenance purposes only) - and select employees of our external service providers who support 507 with the administration of recruitment applications, have access to your Job Application Data. </p> <h4>2.1. For what purposes and how long?</h4> <p> The Job Application Data you provide will be used to assess your application for employment at 507 (or any affiliated 507 entity), to verify your information and conduct reference checks, and to communicate with you and inform you of further career opportunities. If you accept employment with 507 (or an affiliated 507 entity), the informationcollected will become part of your employment record and will be used for employment purposes. </p> <p> Your Job Application Data is stored in our applicant’s data base for two (2) years as from your most recent submission of Job Application Data. You can access your Job Application Data, correct it or delete it at any time as explained below. </p> <h4>2.2 Data Protection Statement: </h4> <p> The personal data you provide in your application and as part of the recruitment process will only be held and processed for the purpose of the selection processes of the 507 and in connection with any subsequent employment or placement, unless otherwise indicated. Your data will be retained only for as long as is permitted by Slovenian legislation and then destroyed. </p> <p> By submitting your personal data and application, you: </p> <p> (1) declare that you have read, understood and accepted the statements set out in this data protection clause; </p> <p> (2) are declaring that the information given in the application is complete and true to the best of your knowledge, and understand that deliberate omissions and incorrect statements could lead to your application being rejected or to your dismissal; </p> <p> (3) are giving your consent to the processing of the information contained in this application and any other personal data you may provide separately in the manner and to the extent described; and </p> <p> (4) are authorising 507 to verify or have verified on their behalf all statements contained in this application and to make any necessary reference checks. </p> <h3>3.0 Your rights</h3> <p> You can access your Job Application Data, correct it or delete it at any time by logging into the 507’s job application webpage <b>jobs.507.eu</b>. You can as well get further information regarding the processing of your Job Application Data and on 507’s general Privacy Policy by sending an e-mail to <b>info@507.eu</b> </p> ";

/***/ },
/* 160 */
/***/ function(module, exports) {

	module.exports = " <article class=\"container col-md-6\" v-if=application.title> <h1>Your Application for <span class=job-title>{{application.title}}</span></h1> <hr/> <ul class=\"list-group changes-list\"> <li data-toggle=\"{{ index == 0 ? 'tooltip' : '' }}\" data-placement=top title={{messages[change.status].message}} v-for=\"(index, change) in application.changes\" class=\"list-group-item status-{{ change.status }}\"> <h4 class=list-group-item-heading style=\"width: 100%\"> <span class=\"\">{{ messages[change.status].title }}</span> <small class=\"text-muted pull-md-right\">{{ change.created | date '%a %d.%m %R' }}</small> </h4> <div id=interview class=\"interview-selecting list-group-item-text\" v-if=\"application.changes[0].status == 3 && change.status == 3 && index == 0\"> <p>{{ change.description }}</p> <div class=interview-date> <div class=assigned-date> <p>Interview Date: {{ application.interview.date }}</p> <button v-on:click=confirmInterview class=\"btn btn-507 center-block\">Confirm Visit</button> </div> <i>In case you are not available on our propose date, please suggest your first available termin.</i> <div class=suggest-date> <p>Suggest your Date</p> <div id=interviewDate></div> <p>Note <input v-model=newDate.note type=text /></p> <div class=button-wrap> <button v-on:click=confirmNewDate class=\"btn btn-507 center-block\">suggest New Date</button> </div> </div> </div> </div> <div v-else> <div v-if=\"application.changes[0].status == 4 && change == application.changes[0]\" class=list-group-item-text> <p> You have interview <strong>{{ application.interview.date }}</strong>, <a href=https://goo.gl/maps/amL8CXuznB52 class=map-link target=_blank>Vilharjeva cesta 3, 1000 Ljubljana</a> </p> <map :center=mapLocation.center :zoom=15 :options=mapOptions> <marker :position.sync=mapLocation.pos :clickable=true @g-click=mapMarker></marker> </map> </div> <div v-else v-if=\"index == 0\"> <div v-if=\"application.changes[0].status == 8\"> <button v-on:click=storedYes class=\"btn btn-507 center-block\" :class=\"{ 'light': stored == 2 }\"> Yes, I agree, keep my application for the future </button> <button v-on:click=storedNo class=\"btn btn-507 center-block\" :class=\"{ 'light': stored == 1 }\"> My application will expire soon, do not keep it </button> </div> <p>{{ change.description }}</p> </div> </div> </li> </ul> </article> <article class=\"container col-md-6\" v-else> <h1>No application found with that UUID</h1> <div class=middle-button> <a v-link=\"'/'\" class=\"btn btn-primary\">Go Home</a> </div> </article> ";

/***/ },
/* 161 */
/***/ function(module, exports) {

	module.exports = " <div class=job-container> <h1 class=title> <span class=title-text> {{ job.title }} </span> </h1> <article class=\"container col-lg-6\"> <div class=description> {{{job.description}}} </div> <application-form keep-alive></application-form> </article> </div> ";

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(137)
	__webpack_require__(128)
	__vue_script__ = __webpack_require__(118)
	__vue_template__ = __webpack_require__(153)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(129)
	__vue_script__ = __webpack_require__(119)
	__vue_template__ = __webpack_require__(154)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(130)
	__vue_script__ = __webpack_require__(120)
	__vue_template__ = __webpack_require__(155)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(131)
	__vue_script__ = __webpack_require__(121)
	__vue_template__ = __webpack_require__(156)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(132)
	__vue_script__ = __webpack_require__(122)
	__vue_template__ = __webpack_require__(157)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(133)
	__vue_script__ = __webpack_require__(123)
	__vue_template__ = __webpack_require__(158)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(134)
	__vue_template__ = __webpack_require__(159)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(135)
	__vue_script__ = __webpack_require__(124)
	__vue_template__ = __webpack_require__(160)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(136)
	__vue_script__ = __webpack_require__(125)
	__vue_template__ = __webpack_require__(161)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.23500d62f87341bc55cb.js